module.exports = __webpack_public_path__ + "img/d-8.bdd26069.png";